import React from 'react';
import './newsletter.css'
import creep from '../assets/creepy-man.png'

const Newsletter = () => {
    return (
        <div className='newsletter-container'>

            <div className='creep-container'><img className='creep-img' src={creep} alt="" /></div>

            <div className='newsletter'>

                <h2>Sign Up For Bastard Emails</h2>
                <p>Yeah, you'll get exclusive offers and reminders, but it's worth it just for the subject lines...</p>
                
                <div className='email-signup'>
                    <div class="klaviyo-form-S6uPdd"></div>
                </div>

            </div>
            <div className='buffer'></div>
        </div>
    )
}

export default Newsletter
